module.exports = __webpack_public_path__ + "img/mariapfarr_2015_ref.199c3988.jpg";